module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external "mobxReact"
// module id = 6
// module chunks = 0 1